import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import { useCallback, useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { ChromePicker } from 'react-color';

export type ColorPickerDialogProps = {
	value: string;
	onChange: (color: string) => void;
};

export default function ColorPickerDialog(props: ColorPickerDialogProps) {
	const [selectedColor, setSelectedColor] = useState<string>(props.value);

	const handleChange = useCallback(
		(color: string) => {
			props.onChange(color);
			setSelectedColor(color);
		},
		[props],
	);

	const decimalToHex = (alpha: number = 0) =>
		alpha === 0 ? '00' : Math.round(255 * alpha).toString(16);

	useEffect(() => setSelectedColor(props.value), [props.value]);

	return (
		<Popover>
			<PopoverTrigger asChild>
				<div className='flex items-center gap-3 cursor-pointer'>
					<div
						className={cn(
							'w-8 h-8 rounded-full cursor-pointer border flex items-center justify-center border-gray-300',
						)}>
						<div
							className='w-6 h-6 rounded-full cursor-pointer border border-gray-300'
							style={{ backgroundColor: selectedColor }}
						/>
					</div>
					<ChevronDown />
				</div>
			</PopoverTrigger>
			<PopoverContent className='bg-transparent border-none shadow-none'>
				<ChromePicker
					color={selectedColor}
					onChange={(color) =>
						handleChange(`${color.hex}${decimalToHex(color?.rgb?.a)}`)
					}
				/>
			</PopoverContent>
		</Popover>
	);
}
